import { ActionTypes } from '../constants/actionTypes.js';
import { api } from "../apis/ComponentApis.js";


export const setFilterPage = (selectedStatus) => ({
    type: ActionTypes.SET_FILTER_PAGE,
    payload: selectedStatus
});

export const setSelectedRow = (params) => ({
    type: ActionTypes.SET_ROW_DETAILS,
    payload: params
});

export const setPageIndex = (pageIndex) => ({   
    type: ActionTypes.SET_PAGE_INDEX,
    payload: pageIndex,
});

// export const gridApiRequestReleaseComponentSummary = (params, signal) => async (dispatch) => {
//     dispatch({
//         type: ActionTypes.FETCH_GRID_API_REQUEST
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const url = `/api/GetReleaseComponent${queryString}`;
//         const response = await api.get(url, { signal });
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_SUCCESS,
//             payload: { res: response.data.value.releaseComponentDetails, lastRow: response.data.value.lastRow }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_FAILURE,
//             payload: error
//         })
//     }
// };

// export const gridApiRequestUserManagement = (params, signal) => async (dispatch) => {
//     dispatch({
//         type: ActionTypes.FETCH_GRID_API_REQUEST
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const url = `/api/GetUserDetails${queryString}`;
//         const response = await api.get(url, { signal });
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_SUCCESS,
//             payload: { res: response.data.value.userDetails, lastRow: response.data.value.lastRow }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_FAILURE,
//             payload: error
//         });
//     }
// };

// export const gridApiRequestAuditLog = (params, signal) => async (dispatch, getState) => {
//     const state = getState();
//     const selectedAuditType = state.auditLogReducer.selectedAuditType;
//     const url = {
//         site: '/api/SiteAuditLog',
//         firmware: '/api/FirmwareAuditLog',
//         release: '/api/GetReleaseAuditLog',
//         "release notification": "/api/ReleasenotificationAudit",
//         user: "/api/UserAuditLog",
//         report: '/api/ReportAuditLog',
//     }
//     const getResponseKey = (key) => {
//         switch (key) {
//             case "site":
//                 return 'siteAuditLogDetails';
//             case "release":
//                 return 'releaseAuditLogDetails';
//             case "firmware":
//                 return 'firmwareAuditLogDetails';
//             case "release notification":
//                 return 'releaseNotificationAuditLogDetails';
//             case "user":
//                 return 'userAuditLogDetails';
//             case "report":
//                 return 'reportAuditLogDetails';
//             default:
//                 return '';
//         }
//     }
//     dispatch({
//         type: ActionTypes.FETCH_GRID_API_REQUEST
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const urlEndpoint = `${url[selectedAuditType]}${queryString}`;
//         const response = await api.get(urlEndpoint, { signal });
//         const responseKey = getResponseKey(selectedAuditType);
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_SUCCESS,
//             payload: { res: response.data.value[responseKey], lastRow: response.data.value.lastRow }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_GRID_API_FAILURE,
//             payload: error
//         })
//     }
// };

// export const gridApiRequestFirmwareReleaseHistory = (params, signal) => async (dispatch, getState) => {
//     dispatch({
//         type: ActionTypes.FETCH_REPORT_GRID_API_REQUEST, payload: { key: 'firmwareReleaseHistory' }
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const url = `/api/FirmwareReleaseHistoryReport${queryString}`;
//         const response = await api.get(url, { signal });
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_SUCCESS,
//             payload: {
//                 key: 'firmwareReleaseHistory',
//                 res: response.data.value.firmwareReleaseHistoryReportlist,
//                 lastRow: response.data.value.lastRow
//             }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_FAILURE,
//             payload: error
//         })
//     }
// };

// export const gridApiRequestTechnicalData = (params, signal) => async (dispatch, getState) => {
//     dispatch({
//         type: ActionTypes.FETCH_REPORT_GRID_API_REQUEST, payload: { key: 'technicalData' }
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const url = `/api/GetTechnicalData${queryString}`;
//         const response = await api.get(url, { signal });
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_SUCCESS,
//             payload: {
//                 key: 'technicalData',
//                 res: response.data.value.technicalDatalist,
//                 lastRow: response.data.value.lastRow
//             }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_FAILURE,
//             payload: error
//         })
//     }
// };

// export const gridApiRequestContractSummary = (params, signal) => async (dispatch, getState) => {
//     dispatch({
//         type: ActionTypes.FETCH_REPORT_GRID_API_REQUEST, payload: { key: 'contractComponentSummary' }
//     });
//     try {
//         const queryString = `?${new URLSearchParams(params).toString()}`;
//         const url = `/api/GetContractComponentSummary${queryString}`;
//         const response = await api.get(url, { signal });
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_SUCCESS,
//             payload: {
//                 key: 'contractComponentSummary',
//                 res: response.data.value.contractComponentSummarylist,
//                 lastRow: response.data.value.lastRow
//             }
//         })
//     } catch (error) {
//         if (error?.name === 'CanceledError') {
//             console.log('Request canceled', error);
//             return;
//         }
//         dispatch({
//             type: ActionTypes.FETCH_REPORT_GRID_API_FAILURE,
//             payload: error
//         })
//     }
// };